import ShareText from './ShareText';
export default ShareText;